import Navbar from "../components/Navbar";
import TaskList from "../components/TaskList";
import styles from "./Home.module.scss";
import { CalendarComponent } from "../components/Calendar/CalendarComponent";
import { createContext, useContext, useRef, useState } from "react";
import FilterMenu from "../components/FilterMenu/FilterMenu";
import { patchFilterPreferences } from "../api";
import { AppContext } from "../AppContext";

export const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const displayedTasksValues = useRef([]);

  return (
    <HomeContext.Provider value={{ displayedTasksValues }}>
      {children}
    </HomeContext.Provider>
  );
};

const Home = () => {
  const emptyFilter = {
    start_date: "",
    end_date: "",
    user_ids: [],
    category_ids: [],
    statuses: [],
    offset: 0,
  };

  const { user } = useContext(AppContext);

  const [taskListUpdateCounter, setTaskListUpdateCounter] = useState(0);
  const [filter, setFilter] = useState({ ...emptyFilter });

  const updateFilter = (newFilter) => {
    setFilter((prev) => ({
      ...prev,
      ...newFilter,
    }));
    patchFilterPreferences(user.id, { filter_data: newFilter }).then((res) => {
      setTaskListUpdateCounter((prev) => prev + 1);
    });
  };

  const clearFilter = () => {
    updateFilter(emptyFilter);
  };

  return (
    <>
      <Navbar />
      <HomeProvider>
        <div className={styles.container}>
          <div className={styles.sidebar}></div>
          <div className={styles.main}>
            <div className={styles.content}>
              <TaskList
                updateCounter={taskListUpdateCounter}
                setUpdateCounter={setTaskListUpdateCounter}
                advFilter={filter}
              />
              <div className={styles.lower_content}>
                <CalendarComponent
                  updateTaskList={() =>
                    setTaskListUpdateCounter(taskListUpdateCounter + 1)
                  }
                />
                <FilterMenu
                  filter={filter}
                  setFilter={updateFilter}
                  clearFilter={clearFilter}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: "1",
                    padding: "8rem",
                  }}
                >
                  {
                    "L'app è ancora in fase di sviluppo, alcune funzionalità potrebbero non funzionare correttamente. Se trovate problemi (ne troverete) segnalatemeli."
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </HomeProvider>
    </>
  );
};

export default Home;
